import React from 'react';

import { FormattedMessage } from 'react-intl';
import { call, put } from 'redux-saga/effects';

import { conversionToolMappingColumnsModel } from '@models/ConversionTool/conversionToolMappingColumns';
import {
  conversionToolColumnsSetMappingColumnsAction,
  conversionToolColumnsSetSelectedValuesFailureAction,
  conversionToolColumnsSetSelectedValuesSuccessAction,
} from '@store/conversionTool/conversionToolColumns/conversionToolColumns.actions';
import { toastError } from '@store/notifications';

export const setSelectedValuesSaga = function* ({ payload }) {
  try {
    yield put(conversionToolColumnsSetSelectedValuesSuccessAction(payload.data));

    const mappingColumns = yield call(conversionToolMappingColumnsModel, payload.data);

    yield put(conversionToolColumnsSetMappingColumnsAction(mappingColumns));

    yield call(payload.onSuccess);
  } catch (error) {
    yield put([
      toastError({
        message: (
          <FormattedMessage
            defaultMessage="An unexpected error occurred, please try again."
            id="global.notification.api-error-default"
          />
        ),
      }),
      conversionToolColumnsSetSelectedValuesFailureAction(),
    ]);
    yield call(payload.setSubmitting, false);
  }
};
